import {
  formatDateToLocalISODate,
  isDateOnlyValue,
  parseDateValuePreservingLocalDay,
} from '@/shared/utils/dates';

export const scheduleDateInputValue = (storedValue?: string | null): string => {
  if (!storedValue) return '';
  const date = parseDateValuePreservingLocalDay(storedValue);
  return Number.isNaN(date.getTime()) ? '' : formatDateToLocalISODate(date);
};

export const changeScheduleDay = (storedValue: string | null | undefined, calendarDay: string, explicitTime?: string): string => {
  if (!calendarDay) return '';
  const newValue = explicitTime ? `${calendarDay}T${explicitTime}` : calendarDay;
  if (!storedValue || isDateOnlyValue(storedValue)) return newValue;
  const preservedTime = parseDateValuePreservingLocalDay(storedValue);
  if (Number.isNaN(preservedTime.getTime())) return newValue;
  const nextDate = parseDateValuePreservingLocalDay(calendarDay);
  // Match shared date parsing and Gantt calendar edits: change the browser's
  // local calendar day, retaining local wall time (including sub-minute time).
  // Serializing the resulting instant to UTC accounts for offsets and DST;
  // copying the original timestamp suffix would retain the wrong offset.
  preservedTime.setFullYear(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate());
  return preservedTime.toISOString();
};
